export const questionnaireEvaluationGetEvaluationIdSuccessReducer = (state, action) => {
    return Object.assign(Object.assign({}, state), { isSaveSuccess: false, evaluationDocId: action.payload });
};
//# sourceMappingURL=questionnaireEvaluationGetEvaluationIdSuccessReducer.js.map